// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__zfKc8","title":"InfoRow_title__2xlYf"};